import { useEffect } from 'react';

// Hält den Mobil-Rahmen an Ort und Stelle (Befund K7).
//
// Zwei Massnahmen, die zusammengehören:
//
//   1. Die Klasse `rahmen-mobil` am <html>-Element. Daran hängt in
//      index.css die Regel, die dem Wurzelelement das Scrollen nimmt.
//      Gesetzt wird sie hier und nicht per CSS-Breitenabfrage, damit
//      genau ein Ort entscheidet, welcher Rahmen gilt: useLayout.
//
//   2. Eine Rückstellung, wenn die Bildschirmtastatur wieder zugeht.
//      Der Gürtel zum Hosenträger: iOS hält sich nicht immer an
//      `overflow: hidden`, wenn es ein fokussiertes Feld ins Bild holen
//      will — es scrollt dann trotzdem und stellt danach nicht zurück.
//      `visualViewport` meldet das Zugehen der Tastatur als
//      Grössenänderung; ist der sichtbare Bereich wieder so hoch wie das
//      Fenster, wird der Rest weggeräumt.

export function useRahmenVerankerung(istMobil: boolean): void {
  useEffect(() => {
    if (!istMobil) return;

    const wurzel = document.documentElement;
    wurzel.classList.add('rahmen-mobil');

    const sichtfeld = window.visualViewport ?? null;

    const zurueckstellen = (): void => {
      // Nur wenn die Tastatur wirklich zu ist. Während sie offen steht,
      // darf der Browser das Feld ins Bild holen — sonst kämpft diese
      // Zeile gegen den Nutzer, der gerade tippt.
      if (sichtfeld !== null && sichtfeld.height < window.innerHeight - 1) return;
      if (wurzel.scrollTop !== 0) wurzel.scrollTop = 0;
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };

    sichtfeld?.addEventListener('resize', zurueckstellen);
    // Auch beim Verlassen eines Feldes: auf manchen Geräten kommt die
    // Grössenänderung erst verzögert oder gar nicht.
    window.addEventListener('focusout', zurueckstellen);

    return () => {
      wurzel.classList.remove('rahmen-mobil');
      sichtfeld?.removeEventListener('resize', zurueckstellen);
      window.removeEventListener('focusout', zurueckstellen);
    };
  }, [istMobil]);
}
